import EditJobDetailsPopup from './EditJobDetailsPopup'

export default EditJobDetailsPopup
